export default {
  brandColor1: '#B51F24',
  complimentaryColor1: '#ffffff',
  brandColor2: '#D5C3A4',
  complimentaryColor2: '#ffffff',
};
